import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as account from '../account'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: account.RESOURCE.payload.dimension.partialId,
      partialId: account.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    default: false,
    description:
      'Indicates expenses in this account should be included in MTDC',
    isOptional: false,
    name: 'Is in MTDC?',
    partialId: PartialId.Standard.create('is_in_mtdc'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
